<template>
  <el-carousel v-if="banners && banners.length > 0" :interval="5000" arrow="always" height="600px">
    <el-carousel-item v-for="item in banners" :key="item.id">
      <div class="article-container">
        <el-col class="text-pannel" :offset="3" :span="8">
          <div class="title">{{item.title}}</div>
          <div class="description">{{item.synopsis}}</div>
          <!-- <div class="details">{{item.details}}</div> -->
          <div class="recommend_evenmore" @click="onMoreClick">
            查看更多
            <i class="el-icon-arrow-right" style="margin-left: 248px;"></i>
          </div>
        </el-col>
        <el-col :offset="1" :span="12">
          <el-image fit="cover" :src="item.onlShowUrl" />
        </el-col>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  props: {
    banners: Array
  },
  methods: {
    onMoreClick() {
      this.$router.push('/articles')
    }
  }
}
</script>

<style lang="scss" scoped>
.article-container {
  padding-top: 48px;
  padding-bottom: 48px;
  height: 100%;
  .title {
    font-size: 24px;
    line-height: 27px;
    color: black;
  }
  .description {
    margin-top: 16px;
    font-size: 18px;
    line-height: 33px;
    color: black;
  }
  .details {
    margin-top: 16px;
    font-size: 14px;
    line-height: 29px;
    color: #898989;
  }
  .el-image {
    width: 100%;
    height: 504px;
  }
  .text-pannel {
    height: 100%;
    position: relative;
    .recommend_evenmore {
      display: block;
      font-size: 18px;
      line-height: 30px;
      width: 351px;
      height: 43px;
      border-bottom: 1px solid #aaaaaa;
      position: absolute;
      bottom: 0;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/articleBanner.vue